module.exports = __webpack_public_path__ + "fonts/pb4-icons.eot";